import { Transaction } from 'services'
import { Address } from 'viem'

// utility functions for sorting TX data
export const byNewest = (a: Transaction, b: Transaction): number => b.addedTime - a.addedTime

export const byAccount =
  (address: Address) =>
  (tx: Transaction): boolean =>
    tx.account === address
